import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=a09266f0&scoped=true&"
import script from "./PersonSelect.vue?vue&type=script&lang=js&"
export * from "./PersonSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09266f0",
  null
  
)

export default component.exports